import { createContext, useContext } from 'react'

import type { TimelineDropPlacement } from './tripPlanCanvasReorder'

export interface TimelineDragContextValue {
  /** Whether item cards should register as draggable (false while streaming / a move is pending). */
  dragEnabled: boolean
  /** The item currently being dragged, so its source card can be dimmed. */
  activeItemId: number | undefined
  /** The item the insertion line is drawn against (before/after per dropPlacement). */
  overItemId: number | undefined
  /** Which edge of overItemId the dragged item would drop into. */
  dropPlacement: TimelineDropPlacement | undefined
  /** A day under the drag with no specific item target, highlighted for an append. */
  overDayId: number | undefined
  /** The unscheduled bucket under the drag, highlighted for an append. */
  overUnplannedStopId: number | undefined
}

export const TimelineDragContext = createContext<TimelineDragContextValue | undefined>(undefined)

export function useTimelineDragContext(): TimelineDragContextValue {
  const context = useContext(TimelineDragContext)
  if (!context) {
    throw new Error('useTimelineDragContext must be used within a TimelineDragContext.Provider')
  }
  return context
}
